module.exports = __webpack_public_path__ + "media/organizations/uni-leipzig-5b83c316.svg";